import React from "react";
import Analytics, { COPY_SHORT_LINK_URL } from "utils/analytics";
import ExternalLink from "components/ExternalLink";
import CopyToClipboard from "components/CopyToClipboard";
import { ENV } from "utils/constants/env";
import { getShortLinkCheckoutUrl } from "utils/shortLink";

const ShortLinkCopy = ({ id, test = false }) => {
  const liveUrl = getShortLinkCheckoutUrl({
    id,
    mode: ENV.PRODUCTION,
    test
  });

  return (
    <div className="flex flex-row items-center">
      <CopyToClipboard
        tooltip="Copy link"
        toast="Copied link to clipboard"
        value={liveUrl}
        onClick={() => {
          Analytics.track(COPY_SHORT_LINK_URL, {
            url: liveUrl
          });
        }}
      />
      <div className="lh-copy word-break-all pa2 bg-content--secondary ba br2 hairline-1 w-100">
        <ExternalLink
          href={liveUrl}
          copy={id}
          customClasses={{
            container: "w-100",
            link:
              "link flex flex-row items-center justify-between link__decoration--hover color-primary pointer w-100 word-break-all",
            copy: "f6 lh-title pr2"
          }}
        />
      </div>
    </div>
  );
};

export default ShortLinkCopy;
